module.exports = __webpack_public_path__ + "static/media/budva-5.a8778e38.jpg";